<template>
  <div>
    <span class="d-block mb-4">
      {{ $t('ACADEMICO.DESCRICAO_FORM_DESCONTOS') }}
    </span>
    <div class="d-flex justify-content-between align-items-center">
      <h6>{{ $t('ACADEMICO.LISTA_DE_DESCONTOS') }}</h6>
      <b-button
        variant="primary"
        class="mb-3"
        @click="abrirModalAdicionarDesconto"
      >
        {{ $t('ACADEMICO.ADICIONAR_DESCONTO') }}
      </b-button>
    </div>

    <b-table
      head-variant="light"
      :empty-text="$t('GERAL.NENHUM_REGISTRO')"
      :items="form.descontos"
      :fields="colunasDesconto"
      responsive
      show-empty
      striped
      hover
    >
      <template #cell(valor)="item">
        {{
          item.item.valor == 0
            ? `${item.item.percentual}%`
            : formatarReal(item.item.valor)
        }}
      </template>
      <template #cell(remover)="item">
        <b-button variant="secondary" @click="removerDesconto(item.item)">
          {{ $t('ACADEMICO.REMOVER') }}
        </b-button>
      </template>
    </b-table>

    <modal-adicionar-descontos
      :form="form"
      :descontos="descontos"
      :exibir="exibirModalAdicionarDesconto"
      @fechar="fecharModalAdicionarDesconto"
    />
  </div>
</template>

<script>
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import mensagem from '@/common/utils/mensagem';
import helpers from '@/common/utils/helpers';
import DescontosService from '@/common/services/descontos/descontos.service';
import ModalAdicionarDescontos from '../../components/modais/ModalAdicionarDescontos';

export default {
  name: 'TabelaDescontosAdicionados',
  components: {
    ModalAdicionarDescontos,
  },
  props: {
    form: { type: Object, default: Object },
  },
  data() {
    return {
      colunasDesconto: [
        {
          key: 'descricao',
          label: this.$t('PRECOS.DESCRICAO'),
        },
        {
          key: 'valor',
          label: this.$t('PRECOS.VALOR'),
        },
        {
          key: 'remover',
          label: this.$t('GERAL.REMOVER'),
        },
      ],
      exibirModalAdicionarDesconto: false,
      descontos: [],
    };
  },
  mounted() {
    this.getDescontos();
  },
  methods: {
    getDescontos() {
      this.$store.dispatch(START_LOADING);
      DescontosService.obterTodos()
        .then(({ data }) => {
          this.descontos = data;
        })
        .catch((err) => {
          this.descontos = [];
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    removerDesconto(item) {
      const indexDoItem = this.form.descontos.findIndex(
        (desconto) => desconto.id === item.id
      );
      if (indexDoItem !== -1) {
        this.form.descontos.splice(indexDoItem, 1);
      }
    },
    formatarReal(value) {
      return helpers.formatarReal(value);
    },

    abrirModalAdicionarDesconto() {
      this.exibirModalAdicionarDesconto = true;
    },

    fecharModalAdicionarDesconto() {
      this.exibirModalAdicionarDesconto = false;
    },
  },
};
</script>
